import axios from 'axios';
import config from './config';
import { messageErrors } from './messageErrors';

export async function callApi(obj: {
  method: 'get' | 'post' | 'put' | 'delete';
  path: string;
  data?: Object | null;
  responseType?: 'blob';
}): Promise<any> {
  let { method, path, data, responseType } = obj;

  if (data) {
    const token = localStorage.getItem('token');
    data = {
      ...data,
      token,
    };
  }

  try {
    const res = await axios.request({
      method,
      // headers: {
      //   Authorization: 'bearer ',
      // },
      url: config.API_URI + path,
      data: data ? data : null,
      responseType,
      // data: data ? JSON.stringify() : null,
    });
    return res.data;
  } catch (e: any) {
    console.log('Error', e);
    console.log(e.response, 'Error Api Call');
    let error = e.response;
    if (e.response && typeof e.response.data === 'string') error = e.response.data + `${e.response.status ? `; Status: ${e.response.status}` : ''} `;
    // else if (e.response && e.response.data) error = e.response.data?.detail || 'Some Error';
    else if (e.response && e.response.status === 500) error = 'Виникла помилка';
    else if (e.response && e.response.status === 401) error = messageErrors.messageAuth;
    else if (e.response && e.response.status === 403) error = messageErrors.messageAccess;
    else if (e.response && e.response.data) error = e.response.data.message;
    else if (!e.response) error = 'Виникла помилка';
    throw error;
  }
}
